import app from "@/common/plugins/vueInstance";

import VueFusionCharts from "vue-fusioncharts";

// import FusionCharts modules and resolve dependency
import FusionCharts from "fusioncharts";
import Charts from "fusioncharts/fusioncharts.charts";
import scrollmsstackedcolumn2dlinedy from "fusioncharts/fusioncharts.msstackedcolumn2dsplinedy";
import zoomline from "fusioncharts/fusioncharts.zoomline";
import FusionTheme from "fusioncharts/themes/fusioncharts.theme.fusion";
import FusionExcel from "fusioncharts/fusioncharts.excelexport";

FusionCharts.options["license"]({
  key: "KqA8ydjB3B3E2A3A11C11A7B4D5C3C1H2C1ixrB1F2gcowc1B6A7A-13mB-9A3H2C2B2C1E7C6E1F5G4A1B3A11B2D3D2ippE1C3C11d1C7A3B4utcH3B5D7moB-9D3C4D2H-7geE3A3B2F4H2D3H2C8B1E4B1zllA33A8a1B9d1dB-11G4F4D3jyA7RA1E3wwi1A1A7A4B6B5F5C3A2H3A2A5B4C3C7E-11==",
  creditLabel: false,
});

app.use(
  VueFusionCharts,
  FusionCharts,
  Charts,
  scrollmsstackedcolumn2dlinedy,
  zoomline,
  FusionTheme,
  FusionExcel
);
